import {useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {Collapse} from "@mui/material";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

import {areaForPath, canWrite} from "@/utils/access";

import "./index.scss";

// Operazioni prioritarie: compaiono a chi può scrivere nell'area della pagina di arrivo.
const QUICK_ACTIONS = [
	{
		label: "Giocatore",
		Icon: PersonAddAltIcon,
		path: "/players/new",
	},
	{
		label: "Squadra",
		Icon: GroupsIcon,
		path: "/manager/teams/new",
	},
	{
		label: "Partita",
		Icon: SportsSoccerIcon,
		path: "/matches/new",
	},
	{
		label: "Allenamento",
		Icon: FitnessCenterIcon,
		path: "/trainings/new",
	},
	{
		label: "Valutazione",
		Icon: AssessmentIcon,
		path: "/players-valuations/new",
	},
	{
		label: "Contratto",
		Icon: DescriptionIcon,
		path: "/manager/players-contracts/new",
	},
	{
		label: "Giocatore scouting",
		Icon: PersonSearchIcon,
		path: "/scouting/players/new",
	},
	{
		label: "Osservazione",
		Icon: TravelExploreIcon,
		path: "/scouting/planning/new",
	},
];

export default function QuickActions({onNavigate}) {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.user);
	const [open, setOpen] = useState(false);

	const actions = QUICK_ACTIONS.filter((a) =>
		canWrite(user, areaForPath(a.path)),
	);
	if (!actions.length) return null;

	const go = (path) => {
		navigate(path);
		onNavigate && onNavigate();
	};

	return (
		<div className="quick-actions">
			<button
				type="button"
				className={
					"quick-actions__toggle" + (open ? " quick-actions__toggle--open" : "")
				}
				onClick={() => setOpen((o) => !o)}
			>
				<AddIcon fontSize="small" />
				<span>Azioni rapide</span>
				{open ? (
					<ExpandLess fontSize="small" />
				) : (
					<ExpandMore fontSize="small" />
				)}
			</button>
			<Collapse in={open} timeout="auto" unmountOnExit>
				<div className="quick-actions__list">
					{actions.map((a) => (
						<button
							key={a.path}
							type="button"
							className="quick-actions__item"
							onClick={() => go(a.path)}
						>
							<a.Icon fontSize="small" />
							<span>{a.label}</span>
						</button>
					))}
				</div>
			</Collapse>
		</div>
	);
}
